import React from 'react';
import styled from 'styled-components';
import { type Ratio } from '../atoms/image';
import Image from '../atoms/image';
import Copy from '../atoms/Copy';
import Seperator from '../atoms/Seperator';
import { GLOBALS } from '../../utils/globals';

interface ImgWithTextProps {
  srcYellow: string;
  imgSrcSmallYellow: string;
  srcBlue: string;
  imgSrcSmallBlue: string;
  alt: string;
  seperator?: boolean;
  label: string | React.ReactNode;
  id?: string;
  ratio: Ratio;
}

const StyledFigure = styled.figure`
  margin: 0 0 var(--distance-m);
`;
const StyledImage = styled(Image)`
  margin: 0 0 var(--distance-5xs);
`;

const ImageWithText = ({
  label,
  srcYellow,
  srcBlue,
  imgSrcSmallYellow,
  imgSrcSmallBlue,
  alt,
  seperator = true,
  id,
  ratio,
}: ImgWithTextProps) => {
  return (
    <article id={id}>
      <StyledFigure>
        <StyledImage
          ratio={ratio}
          src={GLOBALS.theme === 'yellow' ? srcYellow : srcBlue}
          imgSrcSmall={GLOBALS.theme === 'yellow' ? imgSrcSmallYellow : imgSrcSmallBlue}
          lazy="lazy"
          alt={alt}
        />
        <Copy as="figcaption">{label}</Copy>
      </StyledFigure>
      {seperator && <Seperator />}
    </article>
  );
};
export default ImageWithText;
